/**
 * Some of the API's MySQL columns are still utf8mb3: a character outside the Basic Multilingual Plane
 * (emoji and other 4-byte symbols) makes the insert fail (422/500) and the item is lost. Accents, ñ
 * and other Latin text are kept; emoji joiners and variation selectors left behind are removed too.
 *
 * Still used for product names (prod not confirmed as utf8mb4). Person, store and collection names
 * are utf8mb4 in dev and prod, so they only go through `normalizeSpaces` (the API falls back to
 * `tienda` + id for a store URL when the name has no ASCII letters or digits).
 */
export const stripUnsupportedChars = (text) =>
    String(text == null ? '' : text)
        .replace(/[\u{10000}-\u{10FFFF}]/gu, '')
        .replace(/[‍︎️⃣]/g, '');

/** Collapses runs of whitespace and trims. */
export const normalizeSpaces = (text) =>
    String(text == null ? '' : text)
        .replace(/\s+/g, ' ')
        .trim();

/** For a name saved in a utf8mb3 column: strips what it can't store and normalizes spaces. */
export const cleanDbName = (text) => normalizeSpaces(stripUnsupportedChars(text));
